module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "sleep-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.hasWearableAndNoSelfReportedReadings || _vm.isWearableMoreRecent) ? _c('div', {
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTimeInBed'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearableDuration)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTimeAsleep'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearableAsleepDuration)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTonightsPrediction'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearablePredictionDuration)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelEfficiency'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.wearable.efficiency + '%')
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTimeAwake'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearableTimeAwake)
    }
  })])])], 1)], 1)], 1) : _c('div', [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n              "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepLastNight'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.hours)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepAverage'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.average)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepQuality'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.quality + '/10')
    }
  })])], 1)], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "12px",
      "viewBox": "20 194 16 12",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.2435599,197.367016 C24.2435599,196.292061 24.5552121,195.286354 25.0950382,194.418171 C25.2258208,194.208164 25.0286034,193.948647 24.7757338,194.008834 C21.8609512,194.705193 19.7527773,197.267998 20.023386,200.25082 C20.279386,203.066347 22.725299,205.364459 25.7496469,205.627858 C27.8480816,205.810684 29.7555599,205.041843 31.0439077,203.735524 C31.2178208,203.558845 31.069299,203.272148 30.8122556,203.282179 C30.7440816,203.285091 30.6748643,203.286385 30.6056469,203.286385 C27.0919077,203.286385 24.2435599,200.636535 24.2435599,197.367016 Z M28.0501686,194.238904 L28.3691251,195.090908 L29.3388643,195.110647 C29.4619947,195.113235 29.5120816,195.258202 29.4146903,195.327126 L28.6421686,195.873017 L28.9221686,196.736669 C28.9583425,196.846041 28.8251251,196.935351 28.7246034,196.870634 L27.927386,196.356131 L27.1308643,196.870634 C27.0299947,196.935675 26.8981686,196.846041 26.9329512,196.736669 L27.2129512,195.873017 L26.4404295,195.327126 C26.3430382,195.258202 26.3938208,195.113235 26.5162556,195.110647 L27.4859947,195.090908 L27.805299,194.238904 C27.8456469,194.13115 28.0094729,194.13115 28.0501686,194.238904 Z M34.0035599,200.982449 L34.3099947,201.801123 L35.2418208,201.819567 C35.3771251,201.82248 35.4327773,201.982008 35.325299,202.058051 L34.5830382,202.582585 L34.8515599,203.412261 C34.8901686,203.532311 34.7440816,203.631329 34.6334729,203.559169 L33.8679077,203.065052 L33.1026903,203.559169 C32.9920816,203.631329 32.8456469,203.532311 32.8849512,203.412261 L33.1534729,202.582585 L32.4115599,202.058051 C32.3037338,201.982331 32.3597338,201.822156 32.4943425,201.819567 L33.4261686,201.801123 L33.7336469,200.982449 C33.7781686,200.864016 33.9586903,200.864016 34.0035599,200.982449 Z M33.887386,195.047224 L34.3482556,196.276529 L35.7468643,196.304358 C35.9040816,196.307593 35.9691251,196.493332 35.8435599,196.581995 L34.7291251,197.369605 L35.133299,198.616384 C35.1788643,198.756497 35.0094729,198.87137 34.8797338,198.787561 L33.7298208,198.045253 L32.5802556,198.787561 C32.4508643,198.87137 32.2811251,198.756173 32.3266903,198.616384 L32.7305164,197.369605 L31.6157338,196.581995 C31.4912121,196.493656 31.5559077,196.30727 31.7127773,196.304358 L33.1117338,196.276529 L33.5722556,195.047224 C33.6254729,194.909376 33.8352121,194.909376 33.887386,195.047224 Z",
      "id": "Combined-Shape",
      "stroke": "none",
      "fill": "#183B43",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen || _vm.loading
    },
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": _vm.isOpenInput ? 'remove' : 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "1",
      "max": "24",
      "data-vv-rules": 'required|min_value:1|max_value:24',
      "data-vv-name": "hours",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelHours'),
      "errorText": _vm.errors.first('hours'),
      "type": "number",
      "label": _vm.$t('message.labelHours'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hours),
      callback: function($$v) {
        _vm.$set(_vm.model, "hours", _vm._n($$v))
      },
      expression: "model.hours"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('label', {
    staticClass: "mu-text-field-label sliderTitle",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepQuality'))
    }
  }), _vm._v(" "), _c('vue-slider', _vm._b({
    model: {
      value: (_vm.model.quality),
      callback: function($$v) {
        _vm.$set(_vm.model, "quality", $$v)
      },
      expression: "model.quality"
    }
  }, 'vue-slider', _vm.sliderSettings, false)), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.model.quality)
    }
  }), _vm._v("/10")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e019c38","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/Sleep/Sleep.vue
// module id = 3599
// module chunks = 1